import { FeatureGroup, LayersControl } from 'react-leaflet';
import { liveAssetsSelectors } from '@customer/store/apis/streamingApi';
import { useSelector } from 'react-redux';
import AssetMarker from '../markers/asset-marker/AssetMarker';
import { useTranslation } from 'react-i18next';
import { AssetLiveDataUpdate } from '@customer/store/apis/casStreamingSocketClient';
import { useMemo } from 'react';

interface AssetWithPosition extends AssetLiveDataUpdate {
  lat: number;
  lon: number;
}

function isAssetWithPosition(asset: AssetLiveDataUpdate): asset is AssetWithPosition {
  return asset.lat !== null && asset.lon !== null;
}

export function LiveAssetsLayer() {
  const { t } = useTranslation();

  const assets = useSelector(liveAssetsSelectors.selectAll);

  const assetsWithPosition = useMemo<AssetWithPosition[]>(() => {
    return assets.filter((a: AssetLiveDataUpdate) => isAssetWithPosition(a));
  }, [assets]);

  return (
    <LayersControl.Overlay name={t('Assets')} checked={true}>
      <FeatureGroup>
        {assetsWithPosition.map(a => (
          <AssetMarker
            key={a.id}
            id={a.id}
            name={a.n ?? ''}
            position={[a.lat, a.lon]}
            heading={a.hd}
            hardwareType={a.hw}
          />
        ))}
      </FeatureGroup>
    </LayersControl.Overlay>
  );
}

export default LiveAssetsLayer;
